(function () {
  function pad2(n) { return String(n).padStart(2, "0"); }

  function formatDate(date, format) {
    // Supported formats:
    // "dd MMM" (default), "dd MMM yyyy", "MMM dd", "MMM dd, yyyy"
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const dd = pad2(date.getDate());
    const MMM = months[date.getMonth()];
    const yyyy = date.getFullYear();

    switch ((format || "dd MMM").toLowerCase()) {
      case "dd mmm yyyy": return `${dd} ${MMM} ${yyyy}`;
      case "mmm dd": return `${MMM} ${dd}`;
      case "mmm dd, yyyy": return `${MMM} ${dd}, ${yyyy}`;
      case "dd mmm":
      default: return `${dd} ${MMM}`;
    }
  }

  function addDays(base, days) {
    const d = new Date(base);
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  }

  function init(root) {
    const input = root.querySelector("[data-pincode-input]");
    const btn = root.querySelector("[data-pincode-check]");
    const err = root.querySelector("[data-pincode-error]");
    const results = root.querySelector("[data-pincode-results]");
    const out = root.querySelector("[data-delivery-range]");

    if (!input || !btn || !err || !results || !out) return;

    function sanitize() {
      input.value = (input.value || "").replace(/\D/g, "").slice(0, 6);
    }

    function show(valid) {
      err.hidden = valid;
      results.hidden = !valid;
    }

    function computeRange() {
      const minDays = Number(results.getAttribute("data-min-days") || 3);
      const maxDays = Number(results.getAttribute("data-max-days") || 5);
      const fmt = results.getAttribute("data-date-format") || "dd MMM";

      const today = new Date();
      const d1 = addDays(today, minDays);
      const d2 = addDays(today, Math.max(maxDays, minDays));

      const a = formatDate(d1, fmt);
      const b = formatDate(d2, fmt);

      out.textContent = (a === b) ? a : `${a} - ${b}`;
    }

    input.addEventListener("input", sanitize);

    function onCheck() {
      sanitize();
      const ok = /^\d{6}$/.test(input.value);
      show(ok);
      if (ok) computeRange();
    }

    btn.addEventListener("click", onCheck);
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") onCheck();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".pincode-checker").forEach(init);
  });

  // Theme section re-render support (Shopify editor)
  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelectorAll(".pincode-checker").forEach(init);
  });
})();
